import Vue from 'vue'
import editorialDisclosure from './editorial-disclosure.vue'

new Vue({
  el: '#editorial-disclosure',
  render: h => h(editorialDisclosure)
})
